
import axios from 'axios';

// app config
import AppConfig from 'Constants/AppConfig';
import AuthHeader from 'Constants/AuthHeader';
import {
    OCSCORING_ACTION,
    ALL_OCSCORING,
    ADD_OCSCORING,
    FETCH_OCSCORING,
    EDIT_OCSCORING,
    DELETE_OCSCORING,
    FETCH_OCSCORINGCHART,
} from 'Actions/types';

import { NotificationManager } from 'react-notifications';
/**
 * On Course Bunker Play Actions
 */

    export const allOCScoring = () =>{    
    
        return (dispatch) => { 
            dispatch({ type: OCSCORING_ACTION });
            return axios.get(AppConfig.apiurl+'/api/getoncneholetest', { headers: AuthHeader.header })         
            .then(response => {             
                const alldata=response.data.data;
                dispatch({ type: ALL_OCSCORING, payload: alldata });
            });
        }        
    
    }

    export const studentOCScoring = (id, start, end) =>{
    
        var payload={
            "id":id,
            "startdate":start,
            "enddate":end
        }

        return (dispatch) => { 
            dispatch({ type:OCSCORING_ACTION, });
            return axios.post(AppConfig.apiurl+'/api/studentoncneholetest', payload,{ headers: AuthHeader.header })         
            .then(response => { 
                const alldata=response.data.data;
                dispatch({ type: ALL_OCSCORING, payload: alldata }); 
                return Promise.resolve(alldata);
            });

           
        }
    }

    export const addOCScoring = (data, sepmore) =>{
       var stdid=data.target.student.value;
        var payload={
            "totval":1,
            "student_1":data.target.student.value,
            "sgdate":data.target.seldate.value,
            "course":data.target.course.value,
            "shtot_1":sepmore,
        }

        for (let i = 0; i<sepmore; i++) {        
        
            var hlpar='holepar_'+i;            
            var hlparval=data.target[hlpar].value;
            var fwhit='fwhit_'+i;            
            var fwhitval=data.target[fwhit].value;
            var distance='distance_'+i;            
            var distanceval=data.target[distance].value;
            var girhit='girhit_'+i;            
            var girhitval=data.target[girhit].value;
            var puttlength='puttlength_'+i;            
            var puttlengthval=data.target[puttlength].value;
            var noputt='noputt_'+i;            
            var noputtval=data.target[noputt].value;
            var penalties='penalties_'+i;            
            var penaltiesval=data.target[penalties].value;
            var score='score_'+i;            
            var scoreval=data.target[score].value;
            var process='process_'+i;            
            var processval=data.target[process].value;      
            
            var adval=i+1;            
            var hlparadd='holepar_1_'+adval; 
            var fwhitadd='fwhit_1_'+adval; 
            var distanceadd='distance_1_'+adval; 
            var girhitadd='girhit_1_'+adval; 
            var puttlengthadd='lengthputt_1_'+adval; 
            var noputtadd='noputt_1_'+adval;  
            var penaltiesadd='penalty_1_'+adval; 
            var scoreadd='score_1_'+adval; 
            var processadd='process_1_'+adval; 

            payload[hlparadd]=hlparval;
            payload[fwhitadd]=fwhitval;
            payload[distanceadd]=distanceval;
            payload[girhitadd]=girhitval;
            payload[puttlengthadd]=puttlengthval;
            payload[noputtadd]=noputtval;
            payload[penaltiesadd]=penaltiesval;
            payload[scoreadd]=scoreval;
            payload[processadd]=processval;         
    
        }

        return (dispatch) => { 
            dispatch({ type:OCSCORING_ACTION, });
            return axios.post(AppConfig.apiurl+'/api/addoncneholetest', payload,{ headers: AuthHeader.header })         
            .then(response => {             
                var resdata=response.data;
                if(resdata.status===1){
                    var st="";
                    var ed="";
                    studentOCScoring(stdid, st, ed)(dispatch);
                    NotificationManager.success(resdata.message);               
                    dispatch({ type: ADD_OCSCORING});                    
                }
                return Promise.resolve(resdata);
                
            });
        
        }
    }

    export const fetchOCScoring = (id, date) =>{
    
        var payload={
            "id":id,
            "date":date
        }
        return (dispatch) => { 
            dispatch({ type:OCSCORING_ACTION, });
            return axios.post(AppConfig.apiurl+'/api/getoncneholetestdetails', payload,{ headers: AuthHeader.header })         
            .then(response => {             
                var resdata=response.data;
                if(resdata.status===1){              
                    dispatch({ type: FETCH_OCSCORING, payload: resdata.data});                    
                }
                return Promise.resolve(resdata);
                
            });
        
        }
    }

    export const editOCScoring = (data, sepmore, oldate) =>{
        var stdid=data.target.student.value;
        var payload={
            "totval":1,
            "student":data.target.student.value,
            "sgdate":data.target.seldate.value,
            "course":data.target.course.value,
            "shtot_1":sepmore,
            "olddate":oldate,
        }

        for (let i = 0; i<sepmore; i++) {        
        
            var hlpar='holepar_'+i;            
            var hlparval=data.target[hlpar].value;
            var fwhit='fwhit_'+i;            
            var fwhitval=data.target[fwhit].value;
            var distance='distance_'+i;            
            var distanceval=data.target[distance].value;
            var girhit='girhit_'+i;            
            var girhitval=data.target[girhit].value;
            var puttlength='puttlength_'+i;            
            var puttlengthval=data.target[puttlength].value;
            var noputt='noputt_'+i;            
            var noputtval=data.target[noputt].value;
            var penalties='penalties_'+i;            
            var penaltiesval=data.target[penalties].value;
            var score='score_'+i;            
            var scoreval=data.target[score].value;
            var process='process_'+i;            
            var processval=data.target[process].value;      
            
            var adval=i+1;            
            var hlparadd='holepar_1_'+adval; 
            var fwhitadd='fwhit_1_'+adval; 
            var distanceadd='distance_1_'+adval; 
            var girhitadd='girhit_1_'+adval; 
            var puttlengthadd='lengthputt_1_'+adval; 
            var noputtadd='noputt_1_'+adval;  
            var penaltiesadd='penalty_1_'+adval; 
            var scoreadd='score_1_'+adval; 
            var processadd='process_1_'+adval; 

            payload[hlparadd]=hlparval;
            payload[fwhitadd]=fwhitval;
            payload[distanceadd]=distanceval;
            payload[girhitadd]=girhitval;
            payload[puttlengthadd]=puttlengthval;
            payload[noputtadd]=noputtval;
            payload[penaltiesadd]=penaltiesval;
            payload[scoreadd]=scoreval;
            payload[processadd]=processval;         
    
        }

        return (dispatch) => { 
            dispatch({ type:OCSCORING_ACTION, });
            return axios.post(AppConfig.apiurl+'/api/editoncneholetest', payload,{ headers: AuthHeader.header })         
            .then(response => {             
                var resdata=response.data;
                if(resdata.status===1){
                    var st="";
                    var ed="";
                    studentOCScoring(stdid, st, ed)(dispatch);
                    NotificationManager.success(resdata.message);               
                    dispatch({ type: EDIT_OCSCORING});                    
                }
                return Promise.resolve(resdata);
                
            });
        
        }
    }

    export const deleteOCScoring = (id, date) =>{
    
        var payload={
            "id":id,
            "date":date
        }
        
        return (dispatch) => { 
            dispatch({ type:OCSCORING_ACTION, });
            return axios.post(AppConfig.apiurl+'/api/deleteoncneholetest', payload,{ headers: AuthHeader.header })         
            .then(response => {             
                var resdata=response.data;
                if(resdata.status===1){
                    var st="";
                    var ed="";
                    studentOCScoring(id, st, ed)(dispatch);
                    NotificationManager.success(resdata.message);               
                    dispatch({ type: DELETE_OCSCORING});                    
                }                
                
            });
        
        }
    }

    export const fetchOnScoringChart = (id, alldate, course) =>{
    
        var payload={
            "id":id,
            "alldate":alldate,
            "course":course            
        }

        return (dispatch) => { 
            dispatch({ type:OCSCORING_ACTION, });
            return axios.post(AppConfig.apiurl+'/api/oncneholetestreport', payload,{ headers: AuthHeader.header })         
            .then(response => {             
                var resdata=response.data.data;
                dispatch({ type: FETCH_OCSCORINGCHART, payload: resdata});                 
                return Promise.resolve(resdata);
                
            });
        
        }
    }